import commercialStickerCodes from "@/utils/commercial-sticker-codes";
import codesPages from "@/utils/pages-niv3&4-codes";
import {
  commercialPictos,
  commercialPictosTypes
} from "@/utils/picto-commercial";
import {
  addToCartEmits,
  addToCartProps,
  useAddToCart
} from "./add-to-cart.mixin";
import { useProductDetailsTracking } from "@/mixins/tracking/product-details";

export const productListItemProps = () => ({
  index: {
    type: Number,
    required: false
  },
  defaultMaxLabelLength: {
    type: Number,
    required: false,
    default: 78
  },
  commercialStickersAmount: {
    type: Number,
    required: false,
    default: 3
  },
  isSimplifie: {
    type: Boolean,
    required: false,
    default: false
  },
  separator: {
    type: Boolean,
    required: false,
    default: false
  },
  showSuggestions: {
    type: Boolean,
    required: false,
    default: true
  },
  mobileMaxLabelLength: {
    type: Number,
    required: false,
    default: 75
  },
  isCarouselProduct: {
    type: Boolean,
    required: false,
    default: false
  },
  noBorder: {
    type: Boolean,
    required: false,
    default: false
  },
  article: {
    type: Object,
    required: false,
    default: null
  },
  quantite: {
    type: Number,
    required: false,
    default: 0
  },
  quantiteClickAndCollect: {
    type: Number,
    required: false,
    default: 0
  },
  quantiteClickAndCollectTraiteur: {
    type: Number,
    required: false,
    default: 0
  },
  quantiteClickAndCollectTraiteurNoel: {
    type: Number,
    required: false,
    default: 0
  },
  quantiteDrive: {
    type: Number,
    required: false,
    default: 0
  },
  quantiteLdd: {
    type: Number,
    required: false,
    default: 0
  },
  productsListMode: {
    type: String,
    required: false
  },
  reviewNumber: {
    type: Number,
    required: false,
    default: 0
  },
  canDelete: {
    type: Boolean,
    required: false,
    default: false
  },
  indisponible: {
    type: Boolean,
    required: false,
    default: false
  },
  context: {
    type: String,
    required: false,
    default: "productList"
  },
  cartContext: {
    type: String,
    required: false,
    default: ""
  },
  isNational: {
    type: Boolean,
    required: true
  },
  isClientPro: {
    type: Boolean,
    required: false,
    default: false
  },
  mainImageLazy: {
    type: Boolean,
    required: false,
    default: true
  },
  clickAndCollectDuration: {
    type: String,
    required: false,
    default: ""
  },
  isEligibleFullCb: {
    type: Boolean,
    required: false,
    default: false
  },
  isEligibleFullCb3x: {
    type: Boolean,
    required: false,
    default: false
  },
  isEligibleFullCb4x: {
    type: Boolean,
    required: false,
    default: false
  },
  ...addToCartProps()
});

export const productListItemEmits = () => [
  "addToCartPft",
  "indexPoidsChanged",
  "showSimilaires",
  ...addToCartEmits()
];

export const useProductListItem = (props, emit = () => { }) => {
  const { trackProductPage } = useProductDetailsTracking();
  const {
    setQuantity,
    removeItem,
    showTypeDrive,
    showTypeClickAndCollect,
    showTypeTraiteur,
    showTypeTraiteurNoel,
    isClickAndCollectTraiteurWithoutPro,
    isClickAndCollectTraiteurNoelWithoutPro,
    isDrive,
    isClickAndCollect,
    isClickAndCollectTraiteur,
    isClickAndCollectTraiteurNoel,
    isLddOnly,
    isNotEligibleClickAndCollect,
    isClickAndCollectOnly,
    isNotEligibleLdd,
    hasMultiplePaniers
  } = useAddToCart(props, { emit });

  const showCartItemQuantityInputSpinner = ref(false);
  const productSheetUrl = ref("/");
  const indexPoids = ref(0);
  const pftSelected = ref(false);
  const showPopinSuggestions = ref(false);
  const showComplementaires = ref(false);
  const showLots = ref(false);

  const addToCartPft = ({ index, type }) => {
    emit("addToCartPft", { index, type });
  };
  const plageSelected = ({ index, type }) => {
    emit("indexPoidsChanged", { index, type });
  };
  const getLabel = (label, maxLength) => {
    return label.length < maxLength
      ? label
      : label.substring(0, maxLength) + "...";
  };
  const formattedPrice = (price) => {
    const fixedAmount = price ? parseFloat(price).toFixed(2) : price;
    return fixedAmount;
  };

  const displayPopupLot = () => {
    showLots.value = true;
  }

  const showSimilaires = () => {
    emit("showSimilaires");
  };
  const navigateToProductSheet = () => {
    trackProductPage({
      type: trackingCodes.PRODUCTCLICK,
      products: [props.article],
      index: props.index + 1,
      actionField: props.cartContext
    });
  };

  const chooseComplementaryShowType = () => {
    if (
      props.article.attributes.has_produits_complementaires &&
      props.showSuggestions
    ) {
      showComplementaires.value = true;
    }
    if (hasPanachageOrLot.value) {
      showLots.value = true;
    }
  };

  const setQuantityAndShowComplementaires = (qty, typePanier) => {
    setQuantity(qty, typePanier);
    chooseComplementaryShowType();
  };

  const goToProductSheet = () => {
    navigateToInternal(props.article.attributes.slug);
    navigateToProductSheet();
  };

  const url = (code) => {
    try {
      if (!code || !commercialPictosTypes.find((item) => code === item)) {
        return null;
      }
      return commercialPictos[code];
    } catch (error) {
      return null;
    }
  };

  const isContextSuggestion = computed(() => {
    return props.context === "productSuggestions";
  });

  const isBuffet = computed(() => {
    return !!props.article.attributes.qte_pas
  })

  const pagesNiv3et4Codes = computed(() => {
    return codesPages;
  });
  const isPft = computed(() => {
    return (
      props.article.attributes.pft === 1 && !!props.article.attributes.pft_conf
    );
  });
  const productType = computed(() => {
    return props.article && props.article.attributes
      ? props.article.attributes.type
      : null;
  });

  const isTailleCo = computed(() => {
    return productType.value === "TC";
  });

  const name = computed(() => {
    return isTailleCo.value &&
      props.article.attributes.surcharge &&
      Object.prototype.hasOwnProperty.call(
        props.article.attributes.surcharge,
        "designation"
      )
      ? props.article.attributes.surcharge.designation
      : props.article.attributes.designation;
  });
  const isCarteKdo = computed(() => {
    return props.article.attributes.type === "CKDO"
  });

  const amount = computed(() => {
    if (isPft.value) {
      return props.article.attributes.pft_conf.PLAGE[indexPoids.value].PRIX;
    } else if (isCarteKdo.value && props.article.attributes.config_prix) {
      return `${props.article.attributes.config_prix.min} à ${props.article.attributes.config_prix.max}`;
    }
    return isTailleCo.value &&
      props.article.attributes.surcharge &&
      Object.prototype.hasOwnProperty.call(
        props.article.attributes.surcharge,
        "prix"
      ) &&
      props.article.attributes.surcharge.prix
      ? formattedPrice(props.article.attributes.surcharge.prix)
      : formattedPrice(props.article.attributes.prix);
  });

  const showVoirLePrix = computed(() => {
    return (!amount.value || amount.value === "0.00") && props.isNational;
  });

  const pricePerUnit = computed(() => {
    return props.article.attributes.pft === 1 &&
      props.article.attributes.pft_conf?.CONF?.PRIX100G
      ? (props.article.attributes.prix_unite_reference / 10).toFixed(2)
      : props.article.attributes.prix_unite_reference;
  });
  const disabledFlag = computed(() => {
    return isTailleCo.value &&
      props.article.attributes.surcharge &&
      Object.prototype.hasOwnProperty.call(
        props.article.attributes.surcharge,
        "en_stock"
      )
      ? !props.article.attributes.surcharge.en_stock
      : !props.article.attributes.en_stock;
  });
  const discountedAmount = computed(() => {
    if (isPft.value) {
      return props.article.attributes.pft_conf.PLAGE[indexPoids.value]
        .PRIX_BARRE;
    }
    return isTailleCo.value &&
      props.article.attributes.surcharge &&
      Object.prototype.hasOwnProperty.call(
        props.article.attributes,
        "prix_barre"
      ) &&
      props.article.attributes.surcharge.prix_barre
      ? props.article.attributes.surcharge.prix_barre
      : props.article.attributes.prix_barre;
  });
  const discountRate = computed(() => {
    if (isPft.value) {
      return props.article.attributes.pft_conf.PLAGE[indexPoids.value]
        .P100_REDUC &&
        props.article.attributes.pft_conf.PLAGE[0].P100_REDUC !== "0.00"
        ? props.article.attributes.pft_conf.PLAGE[0].P100_REDUC
        : null;
    }
    return props.article.attributes.discount_percent !== "0.00"
      ? props.article.attributes.discount_percent
      : null;
  });
  const advantages = computed(() => {
    return isTailleCo.value &&
      props.article.attributes.surcharge &&
      Object.prototype.hasOwnProperty.call(
        props.article.attributes.surcharge,
        "avantages"
      )
      ? props.article.attributes.surcharge.avantages
      : props.article.attributes.avantages;
  });
  const isProductElectro = computed(() => {
    return (
      props.article.attributes.product_list_item_features &&
      props.article.attributes.product_list_item_features.length > 0
    );
  });
  const isLdd = computed(() => {
    return (
      props.article.attributes.types_panier &&
      props.article.attributes.types_panier.includes("ldd")
    );
  });
  const variantColorNumber = computed(() => {
    return isTailleCo.value &&
      props.article.attributes.variant_axes_available?.axe_two?.values?.length >
      0
      ? props.article.attributes.variant_axes_available.axe_two.values.length
      : 0;
  });
  const isIndisponible = computed(() => {
    return props.indisponible || productType.value === "indisponible";
  });
  const hasPanachageOrLot = computed(() => {
    return props.article.attributes?.avantages?.find(
      (e) => e.lot === 2 || (e.lot === 1 && e.nb_pdt_lot > 1)
    );
  });
  const characteristicsStickers = computed(() => {
    let characteristicsStickers = [];
    const orderedStickers = [];
    if (props.article.attributes?.pictos_caracteristiques?.length > 0) {
      characteristicsStickers =
        props.article.attributes.pictos_caracteristiques.filter(
          (e) => e.type !== "service"
        );
    }

    commercialPictosTypes.forEach((type) => {
      if (characteristicsStickers.find((e) => e.code === type)) {
        orderedStickers.push(
          characteristicsStickers.find((e) => e.code === type)
        );
      }
    });

    return orderedStickers.slice(0, props.commercialStickersAmount);
  });

  const hasOperationSticker = computed(() => {
    return !!props.article.attributes.picto_principal;
  });

  const operationStickersLabel = computed(() => {
    return props.article.attributes.picto_principal.code === "moins_cher"
      ? "Sélection coradrive : le moins cher"
      : props.article.attributes.picto_principal.alt;
  });

  const hasCommercialSticker = computed(() => {
    return characteristicsStickers.value?.length > 0;
  });

  const isAvailableSoon = computed(() => {
    return (
      disabledFlag.value ||
      (isNotEligibleClickAndCollect.value && !props.isNational) ||
      (isNotEligibleLdd.value && !props.isNational)
    );
  });

  const hasEligibility = computed(() => {
    return (
      !props.isNational &&
      props.article.attributes.unavailable_services &&
      props.article.attributes.unavailable_services.length > 0 &&
      !isLdd.value
    );
  });

  const getRemiseAmount = computed(() => {
    return props.article.attributes.prix_avec_remise_sans_appel_fidelite &&
      !disabledFlag.value
      ? props.article.attributes.prix_avec_remise_sans_appel_fidelite
      : null;
  });

  const showQuantityInputSpinner = computed(() => {
    return (
      props.article.attributes.type !== "TC" &&
      !disabledFlag.value &&
      !isPft.value
    );
  });

  const isClickAndCollectInput = computed(() => {
    return (
      showTypeClickAndCollect.value &&
      (props.quantite === 0 ||
        (props.quantite > 0 && props.quantiteClickAndCollect > 0))
    );
  });

  const isDriveInput = computed(() => {
    return (
      showTypeDrive.value &&
      (props.quantite === 0 || (props.quantite > 0 && props.quantiteDrive > 0))
    );
  });

  const prixAPartirDe = computed(() => {
    return (
      (isTailleCo.value &&
        props.article.attributes.surcharge &&
        props.article.attributes.surcharge.prix !== null) ||
      isPft.value
    );
  });

  const uniteRef = computed(() => {
    let uniteRef = props.article.attributes.unite_reference;
    if (uniteRef) {
      uniteRef = uniteRef.substr(uniteRef.indexOf(" ") + 1, uniteRef.length);
    }
    return uniteRef;
  });

  const hasInfoConso = computed(() => {
    return !!(
      props.article?.attributes?.pft_conf?.INFOCONSO &&
      props.article?.attributes?.pft_conf?.CONF?.MODE_AFFICHAGE !== 1
    );
  });

  const hasUnitReference = computed(() => {
    return !!(
      props.article?.attributes?.code_unite_mesure &&
      props.article?.attributes?.valeur_unite_mesure
    );
  });

  const showProductBadge = computed(() => {

    const hasPrime = props.article.attributes.avantages?.find(a => !!a.prime_fid);

    return (
      hasPrime ||
      props.article.attributes.is_deja_achete ||
      props.article.attributes.is_gros_volume ||
      props.article.attributes.picto_commercial?.code ===
      commercialStickerCodes.PROMO ||
      props.article.attributes.is_hyper_bon_plan ||
      props.article.attributes.picto_commercial?.code ===
      commercialStickerCodes.ITS_IN_SEASON ||
      props.article.attributes.is_parapharmacie ||
      (props.article.attributes.types_panier &&
        (props.article.attributes.types_panier.includes(
          "click_and_collect_traiteur_noel"
        ) ||
          props.article.attributes.types_panier.includes(
            "click_and_collect_traiteur_permanent"
          ))) ||
      props.article.attributes.is_prepare_ici ||
      props.article.attributes.is_local ||
      props.article.attributes.is_nouveau ||
      props.article.attributes.boutique_partenaire
    );
  });

  const showPrice = computed(() => {
    return amount.value > 0 || isCarteKdo.value;
  });

  return {
    displayPopupLot,
    showProductBadge,
    hasInfoConso,
    hasUnitReference,
    showLots,
    hasPanachageOrLot,
    //source : addToCart
    setQuantity,
    removeItem,
    isBuffet,
    showTypeDrive,
    showTypeClickAndCollect,
    showTypeTraiteur,
    showTypeTraiteurNoel,
    isClickAndCollectTraiteurWithoutPro,
    isClickAndCollectTraiteurNoelWithoutPro,
    isDrive,
    setQuantityAndShowComplementaires,
    isClickAndCollect,
    isClickAndCollectTraiteur,
    isClickAndCollectTraiteurNoel,
    isLddOnly,
    isNotEligibleClickAndCollect,
    isClickAndCollectOnly,
    isNotEligibleLdd,
    hasMultiplePaniers,
    //refs
    commercialStickerCodes,
    indexPoids,
    pftSelected,
    showCartItemQuantityInputSpinner,
    productSheetUrl,
    showPopinSuggestions,
    showComplementaires,
    //methods
    addToCartPft,
    plageSelected,
    getLabel,
    formattedPrice,
    goToProductSheet,
    navigateToProductSheet,
    showSimilaires,
    url,
    //computed
    pagesNiv3et4Codes,
    isPft,
    productType,
    name,
    amount,
    showVoirLePrix,
    pricePerUnit,
    disabledFlag,
    discountedAmount,
    discountRate,
    advantages,
    isProductElectro,
    isLdd,
    variantColorNumber,
    isIndisponible,
    characteristicsStickers,
    hasCommercialSticker,
    hasOperationSticker,
    isAvailableSoon,
    hasEligibility,
    getRemiseAmount,
    showQuantityInputSpinner,
    isClickAndCollectInput,
    isDriveInput,
    prixAPartirDe,
    uniteRef,
    operationStickersLabel,
    isContextSuggestion,
    isCarteKdo,
    showPrice
  };
};
